const emailRouteComponent = () => import('@/pages/apps/email/index.vue')

// 👉 Redirects
export const redirects = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: to => {
      // 1) grab the raw string
      const raw = localStorage.getItem('userData')
      let user = null

      // 2) only parse if it’s non-empty and not the literal "undefined"
      if (raw && raw !== 'undefined') {
        try {
          user = JSON.parse(raw)
        } catch (e) {
          console.warn('Invalid userData in localStorage:', raw)
          user = null
        }
      }

      if (user?.role?.name === 'Restricted User') {
        return { name: 'apps-v2' }
      }
      if (user) {
        return { name: 'apps-v2' }
      }

      return { name: 'login', query: to.query }
    },
    meta: { public: true },
  },
  {
    path: '/pages/user-profile',
    name: 'pages-user-profile',
    redirect: () => ({ name: 'pages-user-profile-tab', params: { tab: 'profile' } }),
  },
  {
    path: '/pages/account-settings',
    name: 'pages-account-settings',
    redirect: () => ({ name: 'pages-account-settings-tab', params: { tab: 'account' } }),
  },
]
export const routes = [
  // Email filter
  {
    path: '/apps/email/filter/:filter',
    name: 'apps-email-filter',
    component: emailRouteComponent,
    meta: {
      navActiveLink: 'apps-email',
      layoutWrapperClasses: 'layout-content-height-fixed',
    },
  },

  // Email label
  {
    path: '/apps/email/label/:label',
    name: 'apps-email-label',
    component: emailRouteComponent,
    meta: {
      // contentClass: 'email-application',
      navActiveLink: 'apps-email',
      layoutWrapperClasses: 'layout-content-height-fixed',
    },
  },
  {
    path: '/dashboards/logistics',
    name: 'dashboards-logistics',
    component: () => import('@/pages/apps/logistics/dashboard.vue'),
  },
  {
    path: '/dashboards/academy',
    name: 'dashboards-academy',
    component: () => import('@/pages/apps/academy/dashboard.vue'),
  },
  {
    path: '/apps/ecommerce/dashboard',
    name: 'apps-ecommerce-dashboard',
    component: () => import('@/pages/dashboards/ecommerce.vue'),
  },

  // INSIGHTS OVERVIEW AI
  {
    path: '/insights-overview/ai',
    name: 'insights-overview-ai',
    component: () => import('@/pages/insights-overview/ai/index.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
    },
  },

  // INSIGHTS PREVIEW DASHBOARD
  // LOGIN
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login.vue'),
    meta: { guestOnly: true },
  },



]
